import axios from 'axios';
import { getAuthHeader } from '../utils/auth.js';

export const getCustomers = async () => {
  try {
    const response = await axios.get('/api/admin/customers/', {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleCustomerStatus = async (customerId, status) => {
  try {
    const response = await axios.post(
      `/api/admin/customers/${customerId}/toggle_status/`,
      { is_active: status },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCustomerCouriers = async (customerId) => {
  try {
    const response = await axios.get(
      `/api/admin/customers/${customerId}/couriers/`,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCustomerCouriers = async (customerId, courierIds) => {
  try {
    const response = await axios.post(
      `/api/admin/customers/${customerId}/couriers/update/`,
      { courier_ids: courierIds },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAvailableCouriers = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const endpoint = user?.role === 'CUSTOMER' ? 'available-couriers' : 'all-couriers';
    const response = await axios.get(
      `/api/users/${endpoint}/`,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAvailablePorts = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const endpoint = user?.role === 'CUSTOMER' ? 'available-ports' : 'all-ports';
    const response = await axios.get(
      `/api/users/${endpoint}/`,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleCustomerAddressUpdate = async (customerId, canUpdate) => {
  try {
    const response = await axios.patch(
      `/api/admin/customers/${customerId}/toggle_address_update/`,
      { can_update_address: canUpdate },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCustomerDetail = async (customerId) => {
  try {
    const response = await axios.get(
      `/api/admin/customers/${customerId}/detail/`,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCustomerInfo = async (customerId, data) => {
  try {
    const response = await axios.patch(
      `/api/admin/customers/${customerId}/update/`,
      data,
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCustomerPassword = async (customerId, newPassword) => {
  try {
    const response = await axios.post(
      `/api/admin/customers/${customerId}/update_password/`,
      { password: newPassword },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
